export default "__VITE_ASSET__CJLjk594__"